export const reportCodes = {
  CreditMemo: 'CREDIT_MEMO',
  PriceQuote: 'PQ_REPORT',
}
